<template>
  <div class="market-wrap">
    <!--  标题  -->
    <CoinToCoinAccountTitle
      :titles="[this.$t('labels.finance.coinToCoinAcc'), this.$t('labels.finance.addrMgmt')]"
    ></CoinToCoinAccountTitle>
    <!--  表单 -->
    <div class="form-wrap">
      <GForm :config="formConfig" :render-data="form" />
      <div class="form-submit">
        <span @click="openVerifyForm">{{ $t('labels.add') }}</span>
      </div>
    </div>

    <div class="mt-25">
      <AddressTable
        :title="$t('labels.finance.addrMgmt')"
        :data="dataList"
        :coin-id.sync="listFilter.coinId"
        :coin-list="Getter_Assets_List"
        @showGaModal="showGaModal"
      />
    </div>

    <GaModal
      v-if="addAddrGaModalShow"
      @submit="addAddress"
      :show.sync="addAddrGaModalShow"
      :loading="loading"
    />
    <GaModal v-if="gaModalShow" @submit="deleteAddress" :show.sync="gaModalShow" :loading="loading" />
  </div>
</template>
<script>
import CoinToCoinAccountTitle from '../CoinToCoinAccountTitle';
import GForm from '../GForm';
import GaModal from '@/components/GaModal/GaModal';
import AddressTable from './AddressTable';
import { withdrawAddressApi } from '@/api/coinToCoinAccount/withdrawAddressApi';
import { mapGetters } from 'vuex';
import { getterTypes } from '@/store/getter-types';

export default {
  name: 'Banner',
  components: { CoinToCoinAccountTitle, GForm, GaModal, AddressTable },
  data() {
    return {
      model: null,
      currentSymbol: '',
      addAddrGaModalShow: false,
      verifyFormConfig: [
        // { key: 'contactNo', label: '手机号', compType: 'textInput' },
        // { key: 'validateCode', label: '短信验证码', compType: 'textInput', tail: '点击获取', tailFn: () => this.getPhoneCode() },
        // { key: 'email', label: '邮箱', compType: 'textInput' },
        // { key: 'emailValidateCode', label: '邮箱验证码', compType: 'textInput', tail: '点击获取', tailFn: () => this.getEmailCode() },
        {
          key: 'ga_code',
          label: this.$t('labels.gaCode'),
          compType: 'textInput'
          // description: '谷歌验证码丢失？',
          // labelBtnConf: { text: '点击这里', fn: () => {} },
        }
        // { key: 'payPassword', label: '操作密码', compType: 'password' },
      ],
      formConfig: [
        { key: 'name', label: this.$t('labels.remarks'), compType: 'textInput', halfColumn: true },
        // {
        //   key: 'remark',
        //   label: '备注',
        //   compType: 'textInput',
        //   halfColumn: true,
        // },
        {
          key: 'coinId',
          label: this.$t('labels.finance.coin'),
          compType: 'select',
          // options: [{ label: 'USDT', value: '1001', addr: 'USDT' }, { label: 'ETC', value: '1002', addr: 'ETC' }],
          options: [],
          halfColumn: true
        },
        // {
        //   key: 'tag',
        //   label: '标签',
        //   compType: 'select',
        //   options: [{ label: '21131', value: '71789', addr: '79918989' }, { label: '2131', value: '7789', addr: '7998989' }],
        //   halfColumn: true,
        // },
        {
          key: 'addr',
          label: this.$t('labels.finance.walletAddr'),
          compType: 'textInput',
          halfColumn: true
        },
        {
          key: 'memo',
          label: this.$t('labels.finance.memo') + ' ' + this.$t('labels.finance.memo.notes'),
          compType: 'textInput',
          halfColumn: true
        }
      ],
      form: {
        addr: '',
        // emailValidateCode: '',
        // contactNo: '',
        // contactType: '',
        ga_code: '',
        memo: '',
        name: '',
        // payPassword: '',
        publicKey: '',
        // phone: '',
        // email: '',
        validateCode: '',
        // remark: '',
        coinId: ''
        // tag: '',
      },
      listFilter: {
        coinId: ''
      },
      dataList: [],
      gaModalShow: false,
      ga_code: '',
      addressId: '',
      addrValidation: {
        XRP: /(^r|X)\w+/,
        MXW: /^(mxw)\w{39}$/
      },
      loading: false
    };
  },
  watch: {
    Getter_Assets_List: function(val) {
      this.formConfig[1].options = val;
      this.form.coinId = val[0].value; // set default coin
      this.listFilter.coinId = val[0].value;
      this.getList();
    },
    'listFilter.coinId': function() {
      this.getList();
    },
    addAddrGaModalShow: function() {
      this.form.ga_code = '';
    },
    gaModalShow: function() {
      this.ga_code = '';
    }
  },
  created() {
    if (this.formConfig[1].options.length === 0) {
      // coin id options
      if (this.Getter_Assets_List.length > 0) {
        this.formConfig[1].options = this.Getter_Assets_List;
        this.form.coinId = this.Getter_Assets_List[0].value;
        this.listFilter.coinId = this.Getter_Assets_List[0].value;
        this.getList();
      }
    }
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Assets_List])
  },
  methods: {
    getCoinSymbolById(coinId) {
      for (let item of this.Getter_Assets_List) {
        if (item.value === coinId) {
          return item.label;
        }
      }
    },
    checkWalletFormat(coinSymbol, addr) {
      let coinRegex = this.addrValidation[coinSymbol];
      if (coinRegex) {
        let regex = new RegExp(coinRegex);
        let testRegex = regex.test(addr);
        return testRegex;
      }
      // only validate specific coins, if no regex found for that coin, return true
      return true;
    },
    openVerifyForm() {
      if (
        this.formConfig.every(item => {
          if (!this.form[item.key] && item.key !== 'memo') {
            this.warningNotify(`${item.label}${this.$t('v.common.cannot.blank')}`);
            return false;
          }
          return true;
        })
      ) {
        let coinSymbol = this.getCoinSymbolById(this.form.coinId);
        if (coinSymbol) {
          let formatCorrect = this.checkWalletFormat(coinSymbol, this.form.addr);
          if (!formatCorrect) {
            this.errorNotify(this.$t('v.common.walletAddr.format'));
            return;
          }
        }
        this.addAddrGaModalShow = true;
      }
    },
    getList() {
      withdrawAddressApi.getWithdrawAddressByCoinId(this.listFilter.coinId).then(res => {
        this.dataList = res.data;
      });
    },
    showGaModal(row) {
      this.gaModalShow = true;
      this.addressId = row.id;
    },
    deleteAddress(gaCode) {
      const data = {
        addressId: this.addressId,
        ga_code: gaCode
      };
      this.loading = true;
      withdrawAddressApi
        .delete(data)
        .then(res => {
          if (res.errcode === 0) {
            this.gaModalShow = false;
            this.successNotify(this.$t('success.wallet.delete'));
            // this.getList();
            this.reInit();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reInit() {
      this.form = {
        addr: '',
        // emailValidateCode: '',
        // contactType: '',
        // fundPassword: '',
        // ga_code: '',
        memo: '',
        name: '',
        // payPassword: '',
        // publicKey: '',
        // phone: '',
        // email: '',
        validateCode: '',
        // remark: '',
        coinId: ''
        // tag: '',
      };
      this.ga_code = '';
      this.addressId = '';
      this.addAddrGaModalShow = false;
      this.getList();
    },
    getPhoneCode() {},
    getEmailCode() {},
    addAddress(gaCode) {
      const sentData = {
        addr: this.form.addr,
        // contactType,
        // fundPassword: md5(fundPassword),
        ga_code: gaCode,
        memo: this.form.memo,
        name: this.form.name,
        // payPassword: md5(payPassword),
        // publicKey,
        // validateCode,
        coinId: this.form.coinId
      };
      this.loading = true;
      withdrawAddressApi
        .add(sentData)
        .then(res => {
          if (res.errcode === 0) {
            this.successNotify(this.$t('success.wallet.add'));
            this.listFilter.coinId = this.form.coinId;
            this.reInit();
            this.form.coinId = this.listFilter.coinId;
            // this.getList();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped>
.hiddenInput {
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
}
.verify-btn-group {
  display: flex;
  margin-top: 40px;
}
.verify-btn-group > span {
  flex: 1 1 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 44px;
  font-size: 16px;
  border: 1px solid rgba(210, 212, 214, 1);
  color: #d2d4d6;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;
  user-select: none;
}
.verify-btn-group > span:active {
  opacity: 0.8;
}
.verify-btn-group > span.primary {
  background-color: #4d67b2;
  color: #fff;
  border: 1px solid #4d67b2;
}
.verify-btn-group > span:not(:first-child) {
  margin-left: 20px;
}
.verify-wrap {
  width: 500px;
  padding: 24px 30px;
}
.verify-title {
  font-size: 18px;
  font-weight: bold;
  color: rgba(38, 43, 60, 1);
  line-height: 50px;
}
.form-wrap {
  border: 1px solid rgba(230, 234, 240, 1);
  border-radius: 2px;
  padding: 10px;
  margin-top: 20px;
}
.form-submit {
  display: flex;
  justify-content: flex-end;
}
.form-submit > span {
  cursor: pointer;
  display: flex;
  height: 36px;
  line-height: 36px;
  padding: 0 40px;
  background: rgba(77, 103, 178, 1);
  border-radius: 2px;
  color: #fff;
  font-size: 14px;
  margin: 20px 10px 10px 10px;
}
.tmpl {
  flex: 1 1 0px;
}
.goggle-wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
}
.goggle-wrap > div {
  flex: 0 1 50%;
  padding: 10px 30px;
  line-height: 40px;
  font-size: 16px;
  color: rgba(138, 144, 154, 1);
}
.financial-records-btn {
  cursor: pointer;
}
.financial-records-btn > span {
  position: relative;
  display: block;
}
.financial-records-btn > span.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 6px) rotate(45deg);
  border-top: 1px solid rgba(230, 234, 240, 1);
  border-left: 1px solid rgba(230, 234, 240, 1);
  background-color: #fff;
  width: 10px;
  height: 10px;
}
.market-forms {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 10px;
}
.market-forms input {
  border: 1px solid rgba(230, 234, 240, 1);
  border-radius: 2px;
  padding: 0 10px;
  height: 40px;
  line-height: 20px;
  font-size: 14px;
  color: #333;
}
.market-content {
  margin-top: 40px;
}
.market-wrap {
  margin: 0 auto;
  max-width: 1200px;
  padding: 0 20px 100px;
}
/* .q-table-container >>> .q-table thead tr th:last-child {
  padding-left: 40px;
} */
.delete-btn {
  min-height: 2em;
}

@media screen and (max-width: 599px) {
  .form-wrap {
    padding: 5px;
  }
  .market-wrap::v-deep .market-title {
    font-size: 0.85rem;
  }
}
</style>
